/*El component message d'Ant Design implementa els següents tipus de missatge:
success, error, info, warning (o warn) i loading*/
import { message } from "antd";

import { alturaMissatgeErrorEnPixels } from "../constantsFormularis";

message.config({
  top: alturaMissatgeErrorEnPixels
});

const missatgePerDefecte = "Error intern del servidor.";
const duracioMissatgePerDefecte = 10;
const funcioAExecutarQuanEsTanquiPerDefecte = null;

/**
 * @param tipus {String}
 * @param contingut {String}
 * @param duracio {String}
 * @param funcioAExecutarQuanEsTanqui {Function}
 * @returns function
 */
const crearMissatgeServidor = (
  tipus,
  contingut,
  duracio,
  funcioAExecutarQuanEsTanqui
) => {
  return message[tipus](contingut, duracio, funcioAExecutarQuanEsTanqui);
};

/**
 * @param contingut {String}
 * @param duracio {Integer}
 * @param funcioAExecutarQuanEsTanqui {Function}
 * @returns function
 */
export const crearMissatgeSuccess = (
  contingut = missatgePerDefecte,
  duracio = duracioMissatgePerDefecte,
  funcioAExecutarQuanEsTanqui = funcioAExecutarQuanEsTanquiPerDefecte
) => {
  return crearMissatgeServidor(
    "success",
    contingut,
    duracio,
    funcioAExecutarQuanEsTanqui
  );
};

/**
 * @param contingut {String}
 * @param duracio {Integer}
 * @param funcioAExecutarQuanEsTanqui {Function}
 * @returns function
 */
export const crearMissatgeWarning = (
  contingut = missatgePerDefecte,
  duracio = duracioMissatgePerDefecte,
  funcioAExecutarQuanEsTanqui = funcioAExecutarQuanEsTanquiPerDefecte
) => {
  return crearMissatgeServidor(
    "warning",
    contingut,
    duracio,
    funcioAExecutarQuanEsTanqui
  );
};

/**
 * @param contingut {String}
 * @param duracio {Integer}
 * @param funcioAExecutarQuanEsTanqui {Function}
 * @returns function
 */
export const crearMissatgeError = (
  duracio,
  contingut = missatgePerDefecte,
  funcioAExecutarQuanEsTanqui = funcioAExecutarQuanEsTanquiPerDefecte
) => {
  //El component de antd si la duració es zero es queda fixe(com si fos infinit). Per tant en cas de ser igual a null li posen el valor per defecte
  duracio = duracio || duracioMissatgePerDefecte;

  return crearMissatgeServidor(
    "error",
    contingut,
    duracio,
    funcioAExecutarQuanEsTanqui
  );
};
